import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { TemplateSummary } from "../services/template-storage";

interface TemplateListProps {
  templates: TemplateSummary[];
  activeId: string | null;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
}

export function TemplateList({
  templates,
  activeId,
  onSelect,
  onDelete,
}: TemplateListProps) {
  if (templates.length === 0) {
    return (
      <div className="text-sm text-muted-foreground px-2 py-6 text-center">
        No saved templates yet.
      </div>
    );
  }

  return (
    <ul className="space-y-1">
      {templates.map((t) => {
        const isActive = t.id === activeId;
        return (
          <li key={t.id}>
            <div
              className={cn(
                "group flex items-center gap-1 rounded-md border border-transparent px-2 py-1.5 text-sm",
                isActive
                  ? "bg-muted border-border"
                  : "hover:bg-muted/60",
              )}
            >
              <button
                type="button"
                onClick={() => onSelect(t.id)}
                className="flex-1 text-left truncate"
                title={t.name}
              >
                {t.name}
              </button>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="h-7 w-7 opacity-0 group-hover:opacity-100"
                aria-label={`Delete ${t.name}`}
                onClick={(e) => {
                  e.stopPropagation();
                  if (
                    window.confirm(
                      `Delete template "${t.name}"? This cannot be undone.`,
                    )
                  ) {
                    onDelete(t.id);
                  }
                }}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
